import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MexicoThankYou.css';
import { initializeCallBooking } from '../callBookingThankYouScript.js'

const MexicoThankYou = () => {
  useEffect(() => {
    // Add meta tags to head

    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Mexico Residency';
    document.head.appendChild(offerMeta);

    // Initialize call booking
    try {
      initializeCallBooking();
    } catch (error) {
      console.error('Error initializing call booking:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="mexico-thank-you-container">
      <div className="thank-you-content">
        <div className="success-icon">
          🇲🇽 ✅
        </div>
        <h1>Thank You for Your Mexico Residency Inquiry!</h1>
        <p>We've received your message and will contact you shortly about Mexico residency options.</p>
        
        <div className="next-steps">
          <h3>What Happens Next?</h3>
          <ul>
            <li>Our Mexico immigration agent Sergei will review your inquiry</li>
            <li>You'll receive a response soon</li>
            <li>We'll discuss your specific situation and residency options</li>
            <li>Get personalized guidance through the application process</li>
          </ul>
        </div>

        <div className="additional-resources">
          <h3>While You Wait</h3>
          <p>Explore our other relocation services and opportunities:</p>
          <div className="resource-links">
            <Link to="/relocation-services" className="resource-link">
              View All Services
            </Link>
            <Link to="/uae" className="resource-link">
              UAE Setup Guide
            </Link>
            <Link to="/consultation" className="resource-link">
              Book a Consultation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MexicoThankYou;
